import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { organisationsApi } from '../../lib/api';

const NATION_LABELS = { england: 'England', wales: 'Wales', scotland: 'Scotland', northern_ireland: 'Northern Ireland' };
const NATION_SOURCE = {
  set: '', parent: ', from the organisation it sits under',
  placing: ', from the council that placed you', assumed: ', assumed as we don’t know',
};

/**
 * Which nation's rules "What we noticed" checks this organisation against
 * (statutory_gaps.infer_nation), shown on that tab with a way to correct it
 * (PATCH /organisations/{id}/nation).
 */
export const NationLine = ({ orgId, nation, source, onSaved }) => {
  const [editing, setEditing] = useState(false);
  if (!nation) return null;
  const save = async (value) => {
    try {
      await organisationsApi.setNation(orgId, value);
      setEditing(false);
      onSaved?.();
    } catch {
      toast.error('Could not save that.');
    }
  };
  if (editing) {
    return (
      <div className="space-y-2" data-testid="org-nation-edit">
        <p className="text-sm text-ink-55">Which country’s rules applied to them?</p>
        <div className="flex flex-wrap gap-2">
          {Object.entries(NATION_LABELS).map(([value, label]) => (
            <Button key={value} size="sm" variant={value === nation ? 'default' : 'secondary'} onClick={() => save(value)} data-testid={`org-nation-${value}`}>{label}</Button>
          ))}
          <Button size="sm" variant="ghost" onClick={() => setEditing(false)}>Cancel</Button>
        </div>
      </div>
    );
  }
  return (
    <p className="text-sm text-ink-55" data-testid="org-nation">
      Checked against the rules in {NATION_LABELS[nation] || nation}{NATION_SOURCE[source] || ''}.{' '}
      <button type="button" onClick={() => setEditing(true)} className="font-semibold text-brand hover:text-brand-ink">Change</button>
    </p>
  );
};

export default NationLine;
